import { render, staticRenderFns } from "./modal-inbox-new-message.vue?vue&type=template&id=a5d4f0f4"
import script from "./modal-inbox-new-message.vue?vue&type=script&lang=js"
export * from "./modal-inbox-new-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports